import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import History from 'core/utils/history';
import { authenticationActions } from './slice';

/**
 * Landing point for a session handed over by the onboarding wizard.
 *
 * The session arrives in the URL fragment: fragments are never sent to the
 * server, so it stays out of access logs and proxy history the way a query
 * string would not. We read it once, wipe it, and sign in normally.
 */
export default function SessionHandoff() {
  const dispatch = useDispatch();
  // StrictMode double-invokes effects, which would sign in twice.
  const consumed = useRef(false);

  useEffect(() => {
    if (consumed.current) return;
    consumed.current = true;

    const fragment = window.location.hash.replace(/^#/, '');

    // Clear it before any navigation leaves it sitting in history.
    window.history.replaceState(null, '', window.location.pathname);

    if (!fragment) {
      History.navigate('/login');
      return;
    }

    let session: any;
    try {
      session = JSON.parse(atob(decodeURIComponent(fragment)));
    } catch {
      History.navigate('/login');
      return;
    }

    if (!session?.ACCESS_TOKEN) {
      History.navigate('/login');
      return;
    }

    dispatch(authenticationActions.sessionHandoffStart({ session }));
  }, [dispatch]);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
      }}
    >
      <p>Signing you in…</p>
    </div>
  );
}
